var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubtitlesBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.717,
    height: 18.5,
    viewBox: "883.342 164.833 21.717 18.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "subtitles"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M883.342 164.833v14.846h7.507v3.654l6.091-3.654h8.119v-14.846h-21.717Zm20.444 13.573h-7.198l-4.466 2.68v-2.68h-7.508v-12.3h19.172v12.3Z",
    fill: "#6db7f2",
    fillRule: "evenodd",
    "data-name": "Path 118"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M891.19 175.73c1.17 0 2.138-.422 2.77-1.199l-.997-.92c-.45.527-1.016.795-1.687.795-1.256 0-2.148-.882-2.148-2.147 0-1.266.892-2.148 2.148-2.148.671 0 1.237.269 1.687.786l.998-.92c-.633-.767-1.602-1.189-2.762-1.189-2.09 0-3.643 1.448-3.643 3.47 0 2.024 1.553 3.472 3.634 3.472Z",
    fill: "#6db7f2",
    fillRule: "evenodd",
    "data-name": "Path 119"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M898.074 175.73c1.17 0 2.138-.422 2.77-1.199l-.996-.92c-.451.527-1.017.795-1.688.795-1.256 0-2.148-.882-2.148-2.147 0-1.266.892-2.148 2.148-2.148.671 0 1.237.269 1.688.786l.997-.92c-.633-.767-1.601-1.189-2.762-1.189-2.09 0-3.643 1.448-3.643 3.47 0 2.024 1.553 3.472 3.634 3.472Z",
    fill: "#6db7f2",
    fillRule: "evenodd",
    "data-name": "Path 120"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubtitlesBlue);
export default __webpack_public_path__ + "static/media/subtitlesBlue.88590b678613c6630a0e2dfc077d555e.svg";
export { ForwardRef as ReactComponent };